import React from "react";
import { Container } from "react-bootstrap";
import "./FormWrapper.scss";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const FormWrapper = ({
  size = "lg",

  heading,
  children,
}) => {
  return (
    <Container fluid="md" className="text-center mt-5">
      <Row>
        <h3 className="text-center mt-5">{heading}</h3>
        <Col></Col>
        <Col md={4} xs={8}>
          {children}
        </Col>
        <Col />
      </Row>
    </Container>
  );
};

export default FormWrapper;
